// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tNp7","col":"styles_col__2qaR6"};